import styled from "styled-components";
import { Variables } from "../../styles/Variables";

export const Modal = styled.div`
  z-index: 3;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  background-color: rgba(0, 0, 0, 0.2);
`;

export const Content = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 75%;
  min-height: 70px;
  max-height: 500px;
  background-color: #fff;
  border: 1px solid #000;
  border-radius: 10px;
  overflow: hidden;

  @media (max-width: 730px) {
    padding: 20px;
    width: 80%;
  }
`;

export const Close = styled.div`
  position: absolute;
  top: 15px;
  right: 10px;
  width: 20px;
  height: 20px;
  cursor: pointer;

  :hover {
    opacity: 0.8;
  }
`;

export const TextTitle = styled.div`
  height: 90%;
  font-weight: 500;
  overflow-y: auto;
`;
export const TextNegrita = styled.div`
  margin-top: 20px;
  margin-bottom: 20px;
  text-align: center;
  font-weight: 600;
  color: ${Variables.colorBlackDark};
`;

export const TextH = styled.h5`
  display: inline-block;
  color: ${Variables.colorBlackDark};
`;

export const Text = styled.div`
  margin: 10px 0;
`;

export const InfoPrint = styled.div`
  padding: 25px;
  overflow: hidden;
`;

export const ContainerIconPrint = styled.div`
  position: absolute;
  top: 10px;
  left: 5px;
  width: 30px;
  height: 30px;
  cursor: pointer;

  :hover {
    opacity: 0.8;
  }
`;
